export enum RouteNames {
  PlatformConnections = 'PlatformConnections',
  Topology = 'Topology',
}
